<script lang="ts">
  import type { Stats } from '../types';

  interface Props {
    stats: Stats;
  }

  let { stats }: Props = $props();
</script>

<div class="bg-black/50 px-4 py-3 border-b border-white/10 flex gap-4 justify-between text-xs flex-shrink-0">
  <div class="flex items-center gap-2">
    <span class="text-gray-400">👥 Conductores:</span>
    <span class="font-bold text-white">{stats.total_conductors}</span>
  </div>
  <div class="flex items-center gap-2">
    <span class="text-gray-400">📦 Entregas Hoy:</span>
    <span class="font-bold text-white">{stats.total_deliveries}</span>
  </div>
  <div class="flex items-center gap-2">
    <span class="text-gray-400">✅ Exitosas:</span>
    <span class="font-bold text-green-400">{stats.completed}</span>
  </div>
  <div class="flex items-center gap-2">
    <span class="text-gray-400">❌ Fallidas:</span>
    <span class="font-bold text-red-400">{stats.failed}</span>
  </div>
  <div class="flex items-center gap-2">
    <span class="text-gray-400">📊 Cumplimiento:</span>
    <span class="font-bold text-yellow-400">{stats.success_rate}%</span>
  </div>
</div>
